import { useState } from 'react';
import StockDashboardList from './List.jsx';

export default function StockDashboardPage() {
  const [filters, setFilters] = useState({ desde: '', hasta: '' });
  return <StockDashboardList filters={filters} onFiltersChange={setFilters} />;
}
